
<template>
  <div class="page flash-sale">
    <img class="bg-img" src="../../assets/images/activity/flashSale/bg-img.png" />
    <div class="header-logo">
      <img src="../../assets/images/extra-logo.png" />
    </div>
    <!-- 弹幕 -->
    <div class="bullet-screen">
      <div class="bullet-row">
        <div class="dm" v-for="(item, index) in bulletTopList" :key="index">{{item.content}}</div>
      </div>
      <div class="bullet-row row2">
        <div class="dm" v-for="(item, index) in bulletBottomList" :key="index">{{item.content}}</div>
      </div>
    </div>
    <div class="theme">
      <!-- 活动时间对象 -->
      <div class="theme-intro">
        <div class="theme-time">活动时间：9月16日-9月18日</div>
        <div class="theme-target">参与对象：所有IAM博世易加网用户</div>
      </div>
      <div class="intro-img">
        <img src="../../assets/images/activity/flashSale/intro-img.png" />
      </div>
      <div class="theme-exchange">
        <!-- 活动状态 -->
        <div class="flash-points">
          <div class="left-img">
            <img width="100%" src="../../assets/images/activity/flashSale/left-img.png" />
          </div>
          <div class="right-img">
            <img width="100%" src="../../assets/images/activity/flashSale/right-img.png" />
          </div>
          <div class="gift-avator" @click="getGiftDetails()">
            <img width="100%" src="../../assets/images/activity/flashSale/gift.jpg" />
          </div>
          <div class="gift-rule">
            <p style="font-size:12px;margin-bottom:5px">价值31800积分美心月饼礼盒</p>
            <p style="font-size:22.5px;">仅需20000积分</p>
          </div>
          <div class="theme-status">
            <div
              class="theme-box"
              v-for="(item, index) in activityList"
              :key="index"
              :class="{'isFinish': item.activityStatus === '已结束' || item.activityStatus === '已参与' || item.activityStatus === '已抢完', 'isSeckill': item.activityStatus === '立即参与'}"
              @click="getAddress(item.activityStatus)">
              <div style="font-size:16px" :class="{'active': item.activityStatus === '立即参与'}">{{ item.date }}</div>
              <div style="font-size:12px" :class="{'seckillFont': item.activityStatus === '立即参与'}">
                {{item.time}} {{ item.activityStatus }}
                <count-down :endDate="countDownTime" v-if="item.activityStatus === '即将开始'"></count-down>
              </div>
            </div>
          </div>
        </div>

        <!-- 活动说明 -->
        <div class="theme-desc">
          <div class="desc-img">
            <img src="../../assets/images/activity/flashSale/desc-img.png" />
          </div>
          <div class="desc-text">
            <p>1. 本活动有效期为2020年9月16日-9月18日；</p>
            <p>2. 所有IAM博世易加网用户，需注册、登录易加网站方可参与活动；</p>
            <p>3. 活动奖品数量有限（每场20份），兑完截止；</p>
            <p>4. 如出现通过不正当手段抢兑奖品者，易加有权收回该用户已兑换商品；</p>
            <p>5. 活动由博世易加组织，法律允许范围内，最终解释权归博世易加所有。</p>
          </div>
        </div>
        <div @click="viewAtical()">
          <div class="free-gift">
            <img src="../../assets/images/activity/flashSale/free.png" />
          </div>
          <div class="btn-img">
            <img src="../../assets/images/activity/flashSale/btn-img.png" />
          </div>
        </div>
      </div>

      <!-- 收货地址弹窗 -->
      <van-popup v-model="isShowAddress" class="choose-address" :close-on-click-overlay="false" closeable>
        <div style="margin:30px 0 10px">本次秒杀您需要为礼盒支付<span style="color:red">20000</span>积分</div>
        <div class="content-header" style="color:#117281">选择收货地址</div>
        <div class="gift-intro">
          <van-radio-group v-model="address" v-for="item in addressList" :key="item.addressId">
            <van-radio :name="item.addressId" checked-color="#117281" style="font-size:13px">
              <span>{{ item.provinceName }}{{ item.cityName }}{{ item.countyName }}{{ item.detailAddress }}</span><br/>
              <span>{{ item.contactPerson }}&nbsp;&nbsp;{{ item.contactMobile }}</span>
            </van-radio>
          </van-radio-group>
        </div>
        <div class="pop-btn" @click="sureSeckill()">
          确认
        </div>
      </van-popup>

      <van-popup v-model="isShowTips" class="choose-address" :close-on-click-overlay="false">
        <div style="margin:20px 0 10px;text-align:center">{{ popContent }}</div>
        <div class="pop-btn" @click="isShowTips = false">好的</div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import activityApi from '@/api/activity'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
import CountDown from './components/countdown'
export default {
  name: 'seckill',
  components: {
    CountDown: CountDown
  },
  data () {
    return {
      activityList: [
        { date: '9月16日', time: '10点', activityStatus: '未开始' },
        { date: '9月16日', time: '15点', activityStatus: '未开始' },
        { date: '9月17日', time: '10点', activityStatus: '未开始' },
        { date: '9月17日', time: '15点', activityStatus: '未开始' },
        { date: '9月18日', time: '10点', activityStatus: '未开始' },
        { date: '9月18日', time: '15点', activityStatus: '未开始' }
      ],
      activityAllList: [],
      bulletTopList: [
        { content: '易加太土豪了！' },
        { content: '小易小易你最棒惹！' },
        { content: '哇塞，这月饼超级好吃的！' },
        { content: '送礼体面过人，小易给我来一打！' },
        { content: '老铁，冲冲冲！' },
        { content: '拼手速还是拼网速？' },
        { content: '我有嘴巴，你有月饼，我们好般配啊！' },
        { content: '想家了' },
        { content: '博世忠粉前来报到，是不是可以优先考虑一下？' },
        { content: '看我看我看我，金主快点看到我！' },
        { content: '祝大家双节快乐，每天都有修不完的车' },
        { content: '抢到就是赚到' },
        { content: '大家准备好了吗？快要开始拉！' },
        { content: '怎么抢？点按钮就行了吗？' },
        { content: '攒了好久的积分终于可以用啦' }
      ],
      bulletBottomList: [
        { content: '太土豪了吧！还是美心月饼啊' },
        { content: '求抢到的人给个攻略' },
        { content: '进来拜锦鲤，求给我好运吧！！！！' },
        { content: '牢牢抱紧博世的大腿' },
        { content: '我的天！是美心？！太给力了啊' },
        { content: '6666666666~~集满10个6据说有好运' },
        { content: '易加网的小哥哥小姐姐都是好人，快点看到我' },
        { content: '抢到的小伙伴挥挥手' },
        { content: '奥力给~！！！！' },
        { content: '今年中秋又不能回家了，汽修人的无奈' },
        { content: '我要我要我要' },
        { content: '易加的东西总是让我有心动的感觉' },
        { content: '吃过，炒鸡好吃的月饼' },
        { content: '节日快乐' },
        { content: '易加网的活动好多啊，太值了有么有' }
      ],
      isShowAddress: false,
      addressList: [],
      address: '',
      value: '1',
      activityId: '',
      itemId: '',
      flag: -1,
      currentTime: new Date().getTime(),
      countDownTime: '',
      giftId: '4829',
      activityIndex: 0,
      isShowTips: false,
      isExistAddress: false,
      popContent: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.clientInfo = userUtils.getClientInfo()
      if (this.clientInfo) {
        this.isShowTipsDialog()
        this.getSeckillList()
      } else {
        this.$router.push({
          name: 'login',
          params: {
            redirectUrl: 'seckill'
          }
        })
      }
    },

    isShowTipsDialog () {
      let firstStart = localStorage.getItem('firstStart') || ''
      if (firstStart !== '') {
        this.isShowTips = false
      } else {
        localStorage.setItem('firstStart', '1')
        this.isShowTips = true
        this.popContent = '为了保证您秒杀成功并尽快收到礼盒，请提前维护好收货地址'
      }
    },

    // 获取六个活动信息
    getSeckillList () {
      const params = {
        activityCode: 'mid-autumn-2020',
        activityType: '02',
        isPublish: '0'
      }
      activityApi
        .getSeckillList(params)
        .then(res => {
          if (res.data.resultCode === '0') {
            let activityAllList = res.data.resultData.activityList || []
            activityAllList.sort((a, b) => {
              return a.startDate - b.startDate
            })
            this.activityAllList = activityAllList.slice(0, 6)
            this.getStatus(this.activityAllList)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 活动状态 未开始 已结束 立即参与 即将开始
    getStatus (activityAllList) {
      this.flag = -1
      let curTime = new Date().getTime()
      activityAllList.forEach((childItem, index) => {
        if (curTime > childItem.endDate) {
          this.activityList[index].activityStatus = '已结束'
        }
        if (curTime > childItem.startDate && curTime < childItem.endDate) {
          this.seckillGifts(childItem.activityId, index)
        }
        if (curTime < childItem.startDate) {
          this.flag++
          if (this.flag === 0) {
            this.countDownTime = childItem.startDate
            this.activityList[index].activityStatus = '即将开始'
          } else {
            this.activityList[index].activityStatus = '未开始'
          }
        }
      })
    },

    // 获取秒杀信息
    seckillGifts (activityId, index) {
      // 获取秒杀信息，判断礼品是否抢完或者用户已经参与
      const params = {
        activityId: activityId
      }
      this.activityId = activityId
      this.activityIndex = index
      activityApi.seckillGifts(params)
        .then(res => {
          if (res.data.resultCode === '0') {
            // 获取用户参与情况
            let { leftCount, attended, itemId } = res.data.resultData.seckillItemList[0] || []
            this.itemId = itemId
            if (leftCount <= 0) {
              this.activityList[index].activityStatus = '已抢完'
            } else if (attended === '1') {
              this.activityList[index].activityStatus = '已参与'
            } else {
              this.activityList[index].activityStatus = '立即参与'
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 获取地址信息
    getAddress (activityStatus) {
      if (activityStatus !== '立即参与') {
        return false
      } else {
        activityApi.getAddress()
          .then(res => {
            if (res.data.resultCode === '0') {
              this.addressList = res.data.resultData.addressList || []
              if (this.addressList.length !== 0) {
                this.isShowAddress = true
              } else {
                this.isShowTips = true
                this.popContent = '您当前没有收获地址'
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },

    // 选择地址后，确认秒杀
    sureSeckill () {
      if (!this.address) {
        this.$notify({
          type: 'danger',
          message: '没有地址不能进行秒杀！'
        })
      } else {
        const data = {
          activityId: this.activityId,
          itemId: this.itemId,
          addressId: this.address,
          itemQuantity: 1
        }
        activityApi.sureSeckill(data)
          .then(res => {
            if (res.data.resultCode === '0') {
              this.isShowTips = true
              this.popContent = '恭喜您手速秒杀全国88%的网友，成功抢购到好礼'
            }
            if (res.data.resultCode === '02') {
              let sellout = res.data.resultData.sellout || ''
              if (sellout === '1' && this.activityIndex < 5) {
                this.isShowTips = true
                this.popContent = '抱歉，好礼已抢完，下场再接再厉'
              }
              if (sellout === '1' && this.activityIndex === 5) {
                this.isShowTips = true
                this.popContent = '抱歉，好礼已抢完，感谢您的参与'
              }
            }
            this.isShowAddress = false
            this.getSeckillList()
          })
          .catch(err => {
            console.log(err)
            this.isShowAddress = false
            this.getSeckillList()
          })
      }
    },

    // 查看礼品详情
    getGiftDetails () {
      localStorage.setItem('firstStartApp', 'yes')
      window.location.href = commonUtils.getExtraSite() + '/#/goodsDetail/' + this.giftId
    },

    // 查看推文
    viewAtical () {
      window.location.href = 'https://mp.weixin.qq.com/s/9OLGrFrW_PVR8nGFaVaHvw'
    }
  }
}
</script>
<style lang="less" scoped>
.page {
  position: relative;
  min-height: calc(100vh);
  padding-top: 0;
  padding-bottom: 0;
  font-family: PingFangSC-Regular, PingFang SC;
  .bg-img {
    width: 100%;
    position: absolute;
  }
  .header-logo {
    position: relative;
    top: 26px;
    width: 70px;
    img {
      width: 100%;
    }
  }
  .theme {
    position: relative;
    top: 125px;
  }
  .bullet-screen {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    width: 375px;
    height: 55px;
    top: 100px;
    overflow: hidden;
  }
  .bullet-row {
    width: 850%;
    -webkit-animation: danmu 48s linear infinite;
    animation: danmu 48s linear infinite;
    color: #fff;
    padding-left: 100%;
  }
  .dm {
    display: inline-block;
    height: 25px;
    padding: 0px 10px;
    margin-left: 30px;
    font-size: 12px;
    line-height: 25px;
    background-color: rgba(255, 255, 255, 0.3);
    box-sizing: border-box;
    border-radius: 14px;
  }
  .row2 {
    -webkit-transform: translateY(20px);
    transform: translateY(20px);
  }
  @-webkit-keyframes danmu {
    0% {
      -webkit-transform: translateX(0);
    }
    100% {
      -webkit-transform: translateX(-100%);
    }
  }

  @keyframes danmu {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  .theme-intro {
    position: relative;
    width: 211.5px;
    height: 33px;
    margin: 5px auto 0px;
    padding-bottom: 10px;
    color: #ffd076;
    text-align: center;
    font-size: 12px;
    line-height: 16.5px;
    letter-spacing: 1px;
    box-sizing: border-box;
  }
  .intro-img {
    text-align: center;
    img {
      width: 80%;
    }
  }
  .theme-exchange {
    width: 350px;
    margin: 14px auto 0px;
    box-sizing: border-box;
  }
  .flash-points,
  .theme-desc {
    position: relative;
    width: 100%;
    border: 0.5px solid #84AAE8;
    background-color: rgba(48, 79, 159, 0.8);
    border-radius: 5px;
  }
  .left-img {
    position: absolute;
    width: 72px;
    top: 30px;
    left: -12.5px;
    z-index: 10;
  }
  .right-img {
    position: absolute;
    width: 63px;
    right: -12.5px;
    top: 132px;
  }
  .gift-avator {
    width: 120px;
    height: 120px;
    margin: 15px auto;
    border-radius: 10px;
    img {
      border-radius: 7px;
    }
  }
  .gift-rule {
    color: #ffd076;
    letter-spacing: 2px;
    text-align: center;
  }
  .theme-status {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 10px 10px 0px 10px;
    box-sizing: border-box;
    .theme-box {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 156px;
      height: 45px;
      padding: 3px 0px;
      margin-bottom: 10px;
      color: #ffffff;
      background-color: #434343;
      text-align: center;
      border-radius: 5px;
      box-sizing: border-box;
    }
  }
  .theme-desc {
    width: 100%;
    margin-top: 10px;
    .desc-img {
      width: 85px;
      margin: 20px auto 0px;
      img {
        width: 100%;
        vertical-align: middle;
      }
    }
    .desc-text {
      padding: 20px;
      color: #ffd076;
      font-size: 12px;
      letter-spacing: 1px;
      line-height: 16px;
    }
  }
  .free-gift {
    width: 320px;
    padding: 5px 10px;
    margin: 10px auto;
    box-sizing: border-box;
    img {
      width: 100%;
    }
  }
  .btn-img {
    width: 125px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
.choose-address {
  width: 80%;
  margin: 0 auto;
  padding: 20px 30px;
  border-radius: 10px;
  box-sizing: border-box;
  line-height: 1.5;
  background-color: #fff;
  .content-header {
    font-size: 15px;
    font-weight: bold;
  }
  .gift-intro {
    font-size: 14px;
    margin-top: 10px;
  }
}
.pop-btn {
  width: 180px;
  height: 35px;
  margin: 20px auto 0px;
  background-color: #117281;
  color: #ffffff;
  line-height: 35px;
  text-align: center;
  border-radius: 5px;
}
.isSeckill {
  font-size: 16px;
  background-color: #30bf5a !important;
}
.isFinish {
  background-color: #acacac !important;
}
.active {
  font-size: 12px !important;
}
.seckillFont {
  font-size: 16px !important;
}
.van-radio-group {
  margin-bottom: 5px;
}
</style>
<style>
  .gift-intro .van-radio__label {
    color: #000000;
  }
</style>
